import * as Yup from "yup";
import validationUtils from "./validationUtils.js";

const pickUpPointSchema = Yup.object().shape({
  address: validationUtils?.validateRequiredAddress("address"),

  city: validationUtils?.validateRequiredAddress("city"),

  state: validationUtils?.validateRequiredAddress("state"),

  zipcode: validationUtils?.validateRequiredAddress("zipcode"),
});

export default pickUpPointSchema;
